import { useParams } from 'react-router';
import { Text, makeStyles } from '@fluentui/react-components';
import OnboardingChecklist from '../components/OnboardingChecklist';
import { useT } from '../i18n';
import { usePageTitle } from '../hooks/usePageTitle';

const useStyles = makeStyles({
  root: { display: 'flex', flexDirection: 'column', gap: '16px', maxWidth: '720px' },
});

/** Sección "Primeros pasos": checklist de arranque (movido desde el Inicio). */
export function GettingStartedPage() {
  const s = useStyles();
  const t = useT();
  usePageTitle(t.nav.gettingStarted);
  const { tenantId } = useParams<{ tenantId: string }>();

  return (
    <div className={s.root}>
      <Text size={600} weight="semibold">{t.nav.gettingStarted}</Text>
      {tenantId && <OnboardingChecklist tenantId={tenantId} />}
    </div>
  );
}
